var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    rx: 41,
    fill: "#703FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 36.5386C57.8308 30.7873 53.2637 26.2202 47.5124 26.2202C45.6517 26.2202 42.7761 27.5734 41.592 29.7724C41.4229 30.2799 40.7463 30.2799 40.5771 29.7724C39.2239 27.7425 36.5174 26.3893 34.4876 26.3893C28.9055 26.3893 24.1692 30.9565 24 36.5386V36.8769C24 39.7525 25.1841 42.459 27.2139 44.4888C27.2139 44.4888 27.2139 44.4888 27.2139 44.658C27.3831 44.8271 35.5025 51.9316 39.2239 55.1455C40.2388 55.9913 41.7612 55.9913 42.7761 55.1455C46.4975 51.9316 54.4478 44.8271 54.7861 44.658C54.7861 44.658 54.7861 44.658 54.7861 44.4888C56.8159 42.6281 58 39.9216 58 36.8769V36.5386Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.8089879cc697ed2235073bcd7a50ccfd.svg";
export { ForwardRef as ReactComponent };